export class Counter {
    private postId: number;
    private readonly COOKIE_PREFIX = 'rr_view_';

    constructor() {
        this.postId = +(document.body.dataset.postId ?? -1);
    }

    private hasCookie(postId: number): boolean {
        return document.cookie.split(';')
            .some(cookie => cookie.trim().startsWith(`${this.COOKIE_PREFIX}${postId}=`));
    }

    async incrementPostViews(): Promise<void> {
        if (this.postId === -1 || this.hasCookie(this.postId)) {
            return;
        }

        try {
            const response = await fetch(`${wpApiSettings.root}rr/v2/post-views/${this.postId}`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    // 'X-WP-Nonce': wpApiSettings.nonce
                }
            });
    
            if (!response.ok) {
                throw new Error('Failed to increment post views');
            }
        } catch (error) {
            console.error('Error incrementing post views:', error);
        }
    }
}